import { Box, Typography } from '@mui/material';
import { useLanguage } from '../../../utils/i18n';

export default function FuelGauge({ litre = 0, percentage = 0, capacity = 400 }) {
  const { t } = useLanguage();
  const displayCap = capacity > 0 ? `${capacity} L` : '- L';
  return (
    <Box sx={{ border: 1, borderRadius: 1, p: 0.5, borderColor: '#e1e1e1', textAlign: 'center', minWidth: 80 }}>
      <Typography sx={{ fontWeight: 700, fontSize: 12, color: '#1a237e', mt: 1 }}>{t('mapsTracking.fuel', 'Fuel')}</Typography>
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          bgcolor: '#e0e0e0',
          mx: 'auto',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mt: 2
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            height: `${percentage}%`,
            bgcolor: percentage < 20 ? '#d32f2f' : '#4caf50',
            transition: 'height 0.5s ease-in-out'
          }}
        />
        <Typography sx={{ zIndex: 1, fontSize: 11, fontWeight: 900, color: percentage > 50 ? '#fff' : '#000' }}>{percentage}%</Typography>
      </Box>
      <Typography sx={{ fontSize: 10, mt: 1 }} display="block">
        {litre} L / {displayCap}
      </Typography>
    </Box>
  );
}
